
export default {
  auth: false,
  layout: 'login',
  data: () => ({
    backendErrors: {},
    loader: false,
    confirmOpen: false,
    data: {
      email: '',
      topic: '',
      content: ''
    }
  }),
  head () {
    return {
      titleTemplate: this.$t('contact.do') + ' - %s',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('meta.contact')
        }
      ],
    }
  },
  methods: {
    // The form is filled in and valid; one last ask before it goes to a queue
    // that cannot answer account questions.
    onSubmit () {
      this.confirmOpen = true
    },
    send () {
      this.confirmOpen = false
      this.loader = true
      this.$axios.post('/api/help-center/contact-not-auth', this.data).then(() => {
        setTimeout(()=>{
          this.loader = false
          window.location.replace('/kontakt')
        }, 1000)

        this.$buefy.toast.open({
          message: this.$t('contact.thanks'),
          type: 'is-success'
        })
      }).catch((e) => {
        this.$sentry.captureException(e)

        setTimeout(()=>{this.loader = false}, 1000)

        if (e.response && e.response.status === 422) {
          this.backendErrors = e.response.data.errors
        } else {
          this.$sentry.captureException(e)

          this.$buefy.toast.open({
            message: this.$t('something_wrong'),
            type: 'is-danger'
          })
        }
      })
    },
  }
}
